import React, { useState, useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGeneralContext } from '../../../context/GeneralContext';
import { INDUSTRY_OPTIONS_MAP } from '../../../services/customizationService';

const getInstanceName = ({ navbar_system_title, navbar_industry_title }) => {
  if (!navbar_system_title || !navbar_industry_title) return '';

  const industryTitle = INDUSTRY_OPTIONS_MAP[navbar_industry_title];
  if (!industryTitle) return '';

  return `${navbar_system_title} ${industryTitle} | Powered by CorGrid ®`;
};

const CenterTitle = () => {
  const { i18n } = useTranslation();
  const [time, setTime] = useState(new Date());
  const { customization } = useGeneralContext();

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Stack
      className="title drop animated zoomIn faster"
      display={{ xs: 'none', lg: 'flex' }}
    >
      <Typography align="center">{getInstanceName(customization)}</Typography>
      <Typography align="center" variant="subtitle2">
        {`${time.toLocaleDateString(i18n.language)} ${time.toLocaleTimeString(
          i18n.language,
        )}`}
      </Typography>
    </Stack>
  );
};

export default CenterTitle;
